// extracted by mini-css-extract-plugin
export default {"noMargin":"Text_noMargin__OY5pi"};